import { render } from "./Pricing.vue?vue&type=template&id=4db1f046"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"

import "./Pricing.vue?vue&type=style&index=0&id=4db1f046&lang=css"
script.render = render

export default script